<template lang="pug">
div
  app-modal-assinar-titulo(
    v-if="showModalAssinatura",
    :idsProcessos="idsProcessosAssinatura",
    @closeModal="closeModalAssinatura"
  )
  app-modal-cancelar-retificacao(
    v-if="showModalRetificacao",
    :idProcesso='idProcesso',
    :numeroProcesso='numeroProcesso',
    :setor='setor'
    @closeModal="closeRetificacao"
  )
  app-modal-visualizar-completo(
    v-if="showModalVisualizarProcesso && idProcesso !== null",
    @closeModal="showModalVisualizarProcesso = false",
    :idProcesso="idProcesso",
    :protocolo="protocolo",
    :numeroProcesso="numeroProcesso",
    :tipo="tipoProcesso"
  )
  app-modal-avocar(
    v-if="showModalAvocar && idsProcessos.length > 0",
    @closeModal="showModalAvocar = false",
    :idsProcessos="idsProcessos"
  )
  app-modal-solicitar-retificacao(
    v-if="solicitarRetificacao",
    :idProcesso="idProcesso",
    :numeroProcesso="numeroProcesso",
    :setor="setorSelecionado",
    @closeModal="solicitarRetificacao = false"
  )
  modal-trocar-responsavel(
    v-if="showModalResponsavel",
    :processo="processoTrocado",
    @closeModal="FECHAR_MODAL_RESPONSAVEL",
    @refresh="refresh"
  )
  el-card.card-container(shadow="hover")
    filtro(
      @pesquisar="pesquisar",
      @limpar="clear",
      :configuracaoFiltro="configuracaoFiltro",
      :filtroRapido="filtroRapido"
      :showFiltroTipoMultiplo="showFiltroTipoMultiplo"
    )
    modal-suspensao-processo(
    v-if="showModalSuspensaoProcesso",
    @closeModal="showModalSuspensaoProcesso = false",
    @refresh='refresh',
    :idProcesso="idProcesso",
    :numeroProcesso="numeroProcesso",
    :caixaSuspensao="false",
    :setor="setor",
    :sIndireta="sIndireta"
  )
  app-listagem(
    :has-refresh-button="true",
    :showButtonOrdemServico="showButtonOrdemServico",
    :showButtonAssinatura="false",
    :has-expansivel="false",
    :json-headers="colunas",
    :json-data="items",
    :totalElements="totalElements",
    :pagina="filtro.pagina",
    :hasFiltroRapido="true",
    :filtro="filtro"
    :infoPrazos="showInfoVencimento() && infoPrazos"
    @atualizarFiltro="atualizarFiltro"
    @updateListagem="refresh",
    @changePage="changePage",
    @sort="sort",
    @exportarCsvFiltroAnalise="exportarCsvFiltroAnalise"
    @executar="executar",
    @selected="CRIAR_ORDEM_SERVICO",
    @selectItem="SELECIONA_PROCESSO"
    @regerar="REGERAR_PROCESSOS"
    :showButtonRegerar="showButtonRegerar()"
  )
  span.padding-left(v-if="showButtonOrdemServico") {{ 'Processos Selecionados: ' + idsProcessos.length }}
</template>

<script>
import { mapGetters, mapActions, mapState } from 'vuex'
import AppListagem from '@/components/AppListagem.vue'
import Filtro from './Filtro'
import FILTRO_EMPTY from '@/models/filtro'
import AppNotificacao from '@/components/mixins/AppNotificacao'
import AppModalVisualizarCompleto from '@/screens/analise/components/modal/AppModalVisualizarCompleto'
import AppModalAvocar from '@/screens/analise/components/modal/AppModalAvocar'
import ModalTrocarResponsavel from '@/screens/analise/components/ModalTrocarResponsavel'
import AppModalAssinarTitulo from '@/screens/analise/components/AppModalAssinarTitulo'
import ModalSuspensaoProcesso from '@/components/ModalSuspensaoProcesso.vue'
import AppModalCancelarRetificacao from '@/screens/analise/components/modal/AppModalCancelarRetificacao'
import AppModalSolicitarRetificacao from '@/screens/analise/components/modal/AppModalSolicitarRetificacao'
import AppModalRegerar from '@/screens/analise/components/modal/AppModalRegerar'
const { filtro, showFiltroTipoMultiplo, isGcgCgir, suspensaoIndireta } = require('@/utils/' + process.env.ESTADO + '/regrasAnalise').default
const BaseFiltro = require('./' + process.env.ESTADO + '/BaseFiltro').default
const { setores } = require('@/utils/' + process.env.ESTADO + '/setor').default

export default {

  beforeRouteLeave (to, from, next) {
    if (to.name !== 'ordem-servico') {
      this.setProcessoSelecionados({ processos: [], map: true })
    }
    next()
  },

  components: {
    AppListagem,
    Filtro,
    AppModalVisualizarCompleto,
    AppModalAvocar,
    ModalTrocarResponsavel,
    AppModalAssinarTitulo,
    AppModalSolicitarRetificacao,
    AppModalRegerar,
    AppModalCancelarRetificacao,
    ModalSuspensaoProcesso
  },

  mixins: [
    BaseFiltro,
    AppNotificacao
  ],

  data () {
    return {
      filtro: FILTRO_EMPTY('CAIXA_ENTRADA'),
      items: [],
      totalElements: 0,
      infoPrazos: undefined,
      setoresInfoVencimento: [ 'GAC', 'GEO', 'GCG', 'CGIR', 'DEAF', 'GDA', 'GRF', 'GAM', 'GEA', 'DJ', 'CDI', 'CPAV', 'GP', 'GIT', 'PROTOCOLO',
        'COMISSAO_ILHA', 'CAF', 'JURIDICO', 'DF1', 'DRF', 'DATGL', 'PRESIDENCIA', 'DUF', 'GRF_CAF',
        'GCG_CGIR'],
      processosSelecionados: [],
      showModalResponsavel: false,
      disabledAnalisar: false,
      showModalVisualizarProcesso: false,
      solicitarRetificacao: false,
      showModalAssinatura: false,
      showModalAvocar: false,
      showModalRetificacao: false,
      processoTrocado: null,
      idProcesso: null,
      numeroProcesso: null,
      tipoProcesso: null,
      setorSelecionado: null,
      protocolo: null,
      idsProcessosAssinatura: [],
      idsProcessos: [],
      configuracaoFiltro: {
        filtroSituacao: filtro?.filtroSituacao?.CAIXA_ENTRADA || [],
        filtroResponsavel: filtro?.filtroResponsavel?.CAIXA_ENTRADA || [],
        filtroReceita: filtro?.filtroReceita?.CAIXA_ENTRADA || [],
        filtroMunicipio: filtro?.filtroMunicipio?.CAIXA_ENTRADA || [],
        filtroOrdemServico: filtro?.filtroOrdemServico?.CAIXA_ENTRADA || [],
        filtroFuncao: filtro?.filtroFuncao?.CAIXA_ENTRADA || [],
        filtroDataVencimento: filtro?.filtroDataVencimento?.CAIXA_ENTRADA || [],
        filtroRua: filtro?.filtroRua?.CAIXA_ENTRADA || [],
        filtroBairro: filtro?.filtroBairro?.CAIXA_ENTRADA || [],
        filtroRemessa: filtro?.filtroRemessa?.CAIXA_ENTRADA || [],
        filtroQuadra: filtro?.filtroQuadra?.CAIXA_ENTRADA || [],
        filtroClausulaResolutiva: filtro?.filtroClausulaResolutiva?.CAIXA_ENTRADA || [],
        filtroVistoriador: filtro?.filtroVistoriador?.CAIXA_ENTRADA || [],
        filtroPerfil: filtro?.filtroPerfil?.CAIXA_ENTRADA || [],
        filtroCpf: filtro?.filtroCpf?.CAIXA_ENTRADA || [],
        filtroDataChegada: filtro?.filtroDataChegada?.CAIXA_ENTRADA || [],
        filtroCadastrante: filtro?.filtroCadastrante?.CAIXA_ENTRADA || []
      },
      showModalSuspensaoProcesso: false,
      colunas: [
        { id: 0, titulo: 'Processo', propriedade: 'numeroProcesso', marcado: () => this.showButtonRegerar(), ordem: 1, acoes: [], type: 'icone', icone: 'comment-alt' },
        { id: 1, titulo: 'CPF/CNPJ do Interessado', propriedade: 'cpfCnpjInteressado', ordem: 2, acoes: [], exibir: () => this.showColuna('filtroCpf') },
        { id: 2, titulo: 'Nome/Razão Social do Interessado', propriedade: 'nomeRazaoSocialInteressado', ordem: 3, acoes: [] },
        { id: 3, titulo: 'Situação', propriedade: 'status', ordem: 4, acoes: [], exibir: () => this.showColuna('filtroSituacao') },
        { id: 4, titulo: 'Município', propriedade: 'municipio', sortable: true, ordem: 3, acoes: [], exibir: () => true },
        { id: 14, titulo: 'Executor', propriedade: 'nomeCadastrante', sortable: true, ordem: 3, acoes: [], exibir: () => this.showColuna('filtroCadastrante') },
        { id: 5, titulo: 'Data Chegada', propriedade: 'dataChegadaSetor', ordem: 4, acoes: [], exibir: () => this.showColuna('filtroDataChegada') },
        { id: 6, titulo: 'Tipo de Processo', propriedade: 'tipo', ordem: 5, acoes: [] },
        { id: 7, titulo: this.isEstadoBA ? 'Analista' : 'Responsável', propriedade: 'responsavel', ordem: 5, acoes: [], exibir: () => true },
        { id: 9, titulo: 'Função', propriedade: 'funcoes', ordem: 5, acoes: [], exibir: () => this.showColuna('filtroFuncao') },
        { id: 12, titulo: 'Status', propriedade: 'isInseridoFluxoMonitoramento', ordem: 5, acoes: [], exibir: () => this.showColuna('filtroClausulaResolutiva') },
        { id: 13, titulo: 'Perfil', propriedade: 'perfil', ordem: 5, acoes: [], exibir: () => this.showColuna('filtroPerfil') },
        { id: 10, titulo: 'Data de vencimento', propriedade: 'dataVencimento', ordem: 5, acoes: [], isPrazo: true, exibir: () => this.showInfoVencimento() },
        {
          id: 11, titulo: 'Ações', propriedade: 'tipo', ordem: 6, //eslint-disable-line
          acoes: [
            { id: 1, nome: 'Analisar Processo', icone: 'fa-file', codigo: 'ANALISAR_PROCESSO', ordem: 1, show: this.showAnalisarProcesso, showToltip: this.showToltip, textToltip: this.textToltip },
            { id: 2, nome: 'Visualizar Processo', icone: 'fa-eye', codigo: 'VISUALIZAR_PROCESSO', ordem: 1, show: this.showVisualizarProcesso },
            { id: 3, nome: this.isEstadoMA ? 'Emitir Boleto' : 'Emitir DAE', icone: 'fa-file-invoice-dollar', codigo: 'EMITIR_DAE', ordem: 1, show: this.showEmitirDae },
            { id: 4, nome: 'Vincular Responsável', icone: 'fa-user-plus', codigo: 'TROCAR_ANALISTA', ordem: 1, show: this.showVincularAnalista },
            { id: 5, nome: 'Trocar Responsável', icone: 'fa-user-edit', codigo: 'TROCAR_ANALISTA', ordem: 1, show: this.showTrocarResponsavel },
            { id: 6, nome: 'Emitir Título', icone: 'fa-file-contract', codigo: 'EMITIR', ordem: 1, show: this.showEmitirTitulo },
            { id: 7, nome: 'Emitir Certidão', icone: 'fa-file-contract', codigo: 'EMITIR', ordem: 1, show: this.showEmitirCertidao },
            { id: 8, nome: 'Retificar Processo', icone: 'fa-check', codigo: 'RETIFICAR_PROCESSO', ordem: 1, show: this.showRetificarProcessso },
            { id: 9, nome: 'Validar Análise', icone: 'fa-check', codigo: 'VALIDAR', ordem: 1, show: this.showValidarProcesso, showToltip: this.showToltip, textToltip: this.textToltip },
            { id: 10, nome: 'Revisar Portaria', icone: 'fa-edit', codigo: 'REVISAR_PORTARIA', ordem: 1, show: this.showRevisarPortaria },
            { id: 11, nome: 'Cadastrar Edital de Impugnação ou Cadastrar Edital de Publicação', icone: 'fa-file', codigo: 'CADASTRAR_EDITAL_IMPUGNACAO_PUBLICACAO', ordem: 1, show: this.showEdital },
            { id: 12, nome: 'Gerar Custas', icone: 'fa-dollar-sign', codigo: 'GERAR_CUSTAS', ordem: 1, show: this.showGerarCustas },
            { id: 13, nome: 'Retornar Setor', icone: 'fa-chevron-left', codigo: 'RETORNAR_SETOR', ordem: 1, show: this.showRetornarSetor },
            { id: 14, nome: 'Solicitar Retificação', icone: 'fa-edit', codigo: 'SOLICITAR_RETIFICACAO', ordem: 1, show: this.showSolicitarRetificacao },
            { id: 15, nome: 'Arquivar Processo', icone: 'fa-archive', codigo: 'ANALISAR_PROCESSO', ordem: 1, show: this.showArquivarProcesso },
            { id: 16, nome: 'Analisar Processo', icone: 'fa-file', codigo: 'ANALISAR_PROCESSO_SEM_TRAMITACAO', ordem: 1, show: this.showAnalisarProcessoSemTramite, showToltip: this.showToltip, textToltip: this.textToltip },
            { id: 17, nome: 'Cadastrar dados da custa', icone: 'fa-file', codigo: 'ANALISAR_PROCESSO', ordem: 1, show: this.showCadastrarDadosCustas, showToltip: this.showToltip, textToltip: this.textToltip },
            { id: 18, nome: 'Emitir ofício', icone: 'fa-file-contract', codigo: 'EMITIR_OFICIO', ordem: 1, show: this.showEmitirOficio },
            { id: 19, nome: 'Revisar ofício', icone: 'fa-file-contract', codigo: 'CONTINUAR_EMISSAO_OFICIO', ordem: 1, show: this.showRevisarOficio },
            { id: 20, nome: 'Calcular VTN', icone: 'fa-calculator', codigo: 'CALCULAR_VTN_AP', ordem: 1, show: this.showCalcularVtnAp, showToltip: this.showToltip, textToltip: this.textToltip },
            { id: 20, nome: 'Calcular VTN', icone: 'fa-calculator', codigo: 'CALCULAR_VTN_MA', ordem: 1, show: this.showCalcularVtnMa },
            { id: 21, nome: 'Calcular VTN', icone: 'fa-calculator', codigo: 'CALCULAR_VTN_RR', ordem: 1, show: this.showCalcularVtnRr },
            { id: 22, nome: 'Conferir Título', icone: 'fa-check', codigo: 'CONFERIR_TITULO', ordem: 1, show: this.showConferirTitulo, showToltip: this.showToltip, textToltip: this.textToltip },
            { id: 23, nome: 'Iniciar Validação Manual', icone: 'fa-file', codigo: 'VALIDACAO_MANUAL', ordem: 1, show: this.showIniciarValidacaoManual },
            { id: 24, nome: 'Emitir Certidão de Área', icone: 'fa-file', codigo: 'EMITIR_CERTIDAO_AREA', ordem: 1, show: this.showEmitirCertidaoArea, showToltip: this.showToltip, textToltip: this.textToltip },
            { id: 25, nome: 'Emitir Extrato de Sentença', icone: 'fa-file', codigo: 'EMITIR_EXTRATO_SENTENCA', ordem: 1, show: this.showEmitirExtratoSentenca },
            { id: 26, nome: 'Elaborar Errata', icone: 'fa-edit', codigo: 'RETIFICAR_TITULO', ordem: 1, show: this.showRetificarTituloCaixaEntrada },
            { id: 27, nome: 'Acusar Entrega', icone: 'fa-file-contract', codigo: 'ACUSAR_ENTREGA', ordem: 1, show: this.showAcusarEntregaTitulo },
            { id: 26, nome: 'Retificar Título', icone: 'fa-edit', codigo: 'RETIFICAR_TITULO', ordem: 1, show: this.showRetificarTituloCaixaEntrada },
            { id: 27, nome: 'Acusar Entrega', icone: 'fa-file-contract', codigo: 'ACUSAR_ENTREGA', ordem: 1, show: this.showAcusarEntregaTitulo, showToltip: this.showToltip, textToltip: this.textToltip },
            { id: 27, nome: 'Acusar Entrega', icone: 'fa-file-contract', codigo: 'ACUSAR_ENTREGA', ordem: 1, show: this.showAcusarEntregaTitulo, showToltip: this.showToltip, textToltip: this.textToltip },
            { id: 28, nome: 'Cancelar Retificação', icone: 'fa-times', codigo: 'CANCELAR_RETIFICACAO', ordem: 1, show: this.showCancelarRetificacaoProcessso },
            { id: 29, nome: 'Suspender Processo', icone: 'fa-edit', codigo: 'VIEW_PROCESSOS_SUSPENSOS', ordem: 1, show: this.showAcaoSuspender, showToltip: this.showToltip }
          ]
        }
      ],

      usuario: null,
      filtroRapido: null,
      showFiltroTipoMultiplo,
      isPa: process.env.ESTADO === 'pa'
    }
  },

  props: {
    tipo: {
      type: String,
      required: false // trocar para true, quando tiver a props
    }
  },

  async created () {
    this.usuario = await this.usuarioLogado
  },

  beforeDestroy () {
    this.ordemServicoClear()
  },

  computed: {
    ...mapGetters({
      usuarioLogado: 'auth/usuarioLogado'
    }),
    ...mapState({
      listaProcessosAuxiliar: state => state.ordemServico.listaProcessosAuxiliar
    }),
    ...mapState('filtroPesquisaGeral', {
      numeroProcessoPesquisaGeral: state => state.numeroProcessoPesquisaGeral
    }),
    showButtonOrdemServico () {
      return false
    }
  },

  methods: {

    ...mapActions({
      ordemServicoClear: 'ordemServico/clear',
      setListaProcessoAuxiliar: 'ordemServico/setListaProcessoAuxiliar',
      retornarSetor: 'processo/retornarSetor',
      setProcessoSelecionados: 'ordemServico/setProcessoSelecionados',
      getPvtnAtivo: 'vtn/getPvtnAtivo',
      checkAnaliseManual: 'processo/checkAnaliseManual',
      getProcessoByProtocolo: 'processos/getProcessoByProtocolo',
      iniciarValidaoManual: 'processo/iniciarValidaoManual',
      exportarCsvAnalise: 'processo/exportarCsvAnalise',
      tramitarComAcao: 'processo/tramitarComAcao',
      regerar: 'filaAnaliseAutomatizada/regerar',
      retirarProcessoDaFila: 'filaAnaliseAutomatizada/retirarProcessoDaFila',
      suspender: 'despacho/criarDespachoSuspensaoProcesso'
    }),

    showButtonRegerar () {
      return isGcgCgir(this.usuario?.perfilSelecionado?.setor?.codigo)
    },

    showColuna (coluna) {
      return this.configuracaoFiltro[coluna].find(perfil => perfil === this.usuario?.perfilSelecionado?.codigo)
    },

    showInfoVencimento () {
      return !!this.setoresInfoVencimento.find(setor => setor === this.usuario?.perfilSelecionado?.setor?.codigo)
    },

    isEstadoBA () {
      return process.env.ESTADO === 'ba'
    },
    isEstadoMA () {
      return process.env.ESTADO === 'ma'
    },
    isEstadoAP () {
      return process.env.ESTADO === 'ap'
    },

    async EMITIR_OFICIO (_this, {item}) {
      await _this.executarTramitacaoByPerfil(item.id)
      this.$router.push({
        name: 'oficio',
        query: {
          idProcesso: item.id
        }
      })
    },
    async CONTINUAR_EMISSAO_OFICIO (_this, { item }) {
      this.$router.push({
        name: 'oficio',
        query: {
          idProcesso: item.id
        },
        params: {
          isEdicao: true
        }
      })
    },
    SELECIONA_PROCESSO (item) {
      item.selecionado = !item.selecionado
      if (item.selecionado) {
        this.idsProcessos.push(item.id)
      } else {
        this.idsProcessos.splice(this.idsProcessos.indexOf(item.id), 1)
      }
      this.setListaProcessoAuxiliar(item)
      this.setProcessoSelecionados({ processos: this.listaProcessosAuxiliar, map: true }) //eslint-disable-line
    },
    async exportarCsvFiltroAnalise () {
      await this.filtroComColunasExibidas()

      this.exportarCsvAnalise(this.filtro)
    },
    CRIAR_ORDEM_SERVICO () {
      if (this.idsProcessos.length > 0) {
        this.$router.push({
          name: 'ordem-servico'
        })
      } else {
        this.showNotificacao(this.$messages.TIPO_WARNING, this.$messages.TITULO_WARNING,
          'Para vincular uma equipe, selecione ao menos um processo.')
      }
    },
    ANALISAR_PROCESSO: async (_this, { item }) => {
      if (_this.isPa && item?.analiseAutomatizadaPendente && setores.GCG_CGIR.includes(item.setor)) {
        _this.confirmBox(_this.$messages.AVISO_ANALISE_AUTOMATIZADA_INCOMPLETA, _this.$messages.TITULO_WARNING,
          async () => {
            await _this.checkAnaliseManual(item.id)
            await _this.executarTramitacao(item.id)
            await _this.retirarProcessoDaFila(item.id)
            _this.$router.push({
              name: 'analise/analisar',
              params: {
                idProcesso: item.id,
                acaoCaixa: 'ANALISE',
                analiseManual: true
              }
            })
          },
          () => { }
        )
      } else if (!_this.disabledAnalisar) {
        _this.disabledAnalisar = true
        try {
          await _this.executarTramitacao(item.id)
          _this.$router.push({
            name: 'analise/analisar',
            params: {
              idProcesso: item.id,
              acaoCaixa: 'ANALISE'
            }
          })
          _this.disabledAnalisar = false
        } catch (e) {
          _this.disabledAnalisar = false
          throw e
        }
      }
    },
    EMITIR_CERTIDAO_AREA: async (_this, { item }) => {
      if (!_this.disabledAnalisar) {
        _this.disabledAnalisar = true
        try {
          await _this.executarTramitacao(item.id)
          _this.$router.push({
            name: 'EMITIR_CERITDAO_AREA',
            params: {
              idProcesso: item.id,
              acaoCaixa: 'ANALISE'
            }
          })
          _this.disabledAnalisar = false
        } catch (e) {
          _this.disabledAnalisar = false
          throw e
        }
      }
    },
    ANALISAR_PROCESSO_SEM_TRAMITACAO: async (_this, { item }) => {
      if (!this.disabledAnalisar) {
        this.disabledAnalisar = true
        _this.$router.push({
          name: 'analise/analisar',
          params: {
            idProcesso: item.id,
            acaoCaixa: 'ANALISE_SEM_TRAMITACAO'
          }
        })
        this.disabledAnalisar = false
      }
    },
    GERAR_CUSTAS: async (_this, { item }) => {
      _this.$router.push({
        name: 'analise/emissao-custas',
        params: {
          idProcesso: item.id,
          acaoCaixa: 'ANALISE'
        }
      })
    },
    RETORNAR_SETOR (_this, { item }) {
      this.retornarSetor({idProcesso: item.id})
        .then(() => {
          _this.refresh()
          this.showNotificacao(this.$messages.TIPO_SUCCESS, this.$messages.TITULO_SUCCESS,
            'Processo retornado ao setor anterior')
        }).catch(({ message }) => {
          this.showNotificacao(this.$messages.TIPO_ERROR, this.$messages.TITULO_ERROR,
            message)
        })
    },
    EDITAR_ORDEM_SERVICO (_this, { item }) {
      this.$router.push({
        name: 'listagem-ordem-servico',
        params: {
          numero: item.numero
        }
      })
    },
    EXCLUIR_ORDEM_SERVICO (_this, { item }) {
      _this.$confirm('Tem certeza que deseja remover este item?', 'Atenção!', {
        confirmButtonText: 'Confirmar',
        cancelButtonText: 'Cancelar',
        type: 'warning'
      }).then(async () => {
        await _this.deleteOrdemServicoPorId(item.id)
        await _this.init()
      })
    },
    RESPONDER_INFORMACOES (_this, { item }) {
      this.$router.push({
        name: 'informacoes',
        params: {
          idSolicitacao: item.id
        }
      })
    },
    VISUALIZAR_PROCESSO (_this, { item }) {
      this.idProcesso = item.id
      this.numeroProcesso = item.numeroProcesso
      this.tipoProcesso = item.tipoCodigo
      this.protocolo = item.numeroProtocolo
      this.showModalVisualizarProcesso = true
    },
    async EMITIR_DAE (_this, { item }) {
      this.$router.push({
        name: 'financeiro/dae/CadastroDae',
        params: {
          idProcesso: item.id
        }
      })
    },
    async EMITIR (_this, { item }) {
      await this.executarTramitacao(item.id)
      this.$router.push({
        name: 'continuar-emissao-titulo',
        params: {
          idProcesso: item.id,
          tipo: 'EMITIR_TITULO',
          urlOrigem: 'CAIXA_ENTRADA'
        }
      })
    },
    async EMITIR_EXTRATO_SENTENCA (_this, { item }) {
      await this.executarTramitacao(item.id)
      this.$router.push({
        name: 'continuar-emissao-extrato-sentenca',
        params: {
          idProcesso: item.id,
          urlOrigem: 'CAIXA_ENTRADA'
        }
      })
    },
    VISUALIZAR_COM_MODAL: (context) => {
      this.showModalResponsavel = true
    },
    GERENCIAR_PROCESSO: () => {
      return 'Gerenciar processo'
    },
    TROCAR_ANALISTA: (_this, { item }) => {
      _this.processoTrocado = item
      _this.showModalResponsavel = true
    },
    ASSINAR_TITULOS () {
      this.showModalAssinatura = true
    },
    FECHAR_MODAL_RESPONSAVEL () {
      this.showModalResponsavel = false
    },
    AVOCAR_PROCESSO (_this, { item }) {
      this.idsProcessos.push(item.id)
      this.showModalAvocar = true
    },
    SOLICITAR_RETIFICACAO (_this, { item }) {
      this.idProcesso = item.id
      this.numeroProcesso = item.numeroProcesso
      this.solicitarRetificacao = true
    },
    VALIDAR: (_this, { item }) => {
      _this.$router.push({
        name: 'analise/validar',
        params: {
          idProcesso: item.id,
          acaoCaixa: 'VALIDACAO'
        }
      })
    },
    CALCULAR_VTN_AP: async (_this, { item }) => {
      const processo = await _this.getProcessoByProtocolo(item.numeroProtocolo)
      const municipioId = 1600105 || processo.dadosCadastro.dados.cadastro.imovel.municipio.id
      await _this.getPvtnAtivo(municipioId)
      await _this.executarTramitacao(item.id)
      _this.$router.push({
        name: 'calcular-vtn-ap',
        params: {
          processo: item,
          acaoCaixa: 'ANALISE'
        }
      })
    },
    CALCULAR_VTN_MA: async (_this, { item }) => {
      await _this.executarTramitacaoByPerfil(item.id)
      _this.$router.push({
        name: 'calcular-vtn-ma',
        params: {
          idProcesso: item.id,
          protocolo: item.numeroProtocolo
        }
      })
    },
    CALCULAR_VTN_RR: async (_this, { item }) => {
      await _this.executarTramitacao(item.id)
      _this.$router.push({
        name: 'calcular-vtn-rr',
        params: {
          processo: item,
          acaoCaixa: 'ANALISE'
        }
      })
    },
    async CONFERIR_TITULO (_this, { item }) {
      if (this.isEstadoMA) {
        await _this.executarTramitacao(item.id)
      }
      this.$router.push({
        name: 'conferencia-titulo-certidao',
        params: {
          idProcesso: item.id,
          tipo: 'EMITIR_TITULO',
          numeroProcesso: item.numeroProcesso
        }
      })
    },
    ACUSAR_ENTREGA: (_this, { item }) => {
      _this.$router.push({
        name: 'analise/acusarEntrega',
        params: {
          idProcesso: item.id,
          acaoCaixa: 'ACUSAR_ENTREGA'
        }
      })
    },
    atualizarFiltro (novoFiltro) {
      this.filtro = {
        ...this.filtro,
        ...novoFiltro
      }

      this.filtroRapido = novoFiltro
    },
    VALIDACAO_MANUAL (_this, { item }) {
      this.iniciarValidaoManual(item.id)
        .then(() => {
          _this.refresh()
          this.showNotificacao(this.$messages.TIPO_SUCCESS, this.$messages.TITULO_SUCCESS,
            'Validação manual iniciada')

          _this.$router.push({
            name: 'analise/analisar',
            params: {
              idProcesso: item.id,
              acaoCaixa: 'ANALISE',
              analiseManual: true
            }
          })
        }).catch(({ message }) => {
          this.showNotificacao(this.$messages.TIPO_ERROR, this.$messages.TITULO_ERROR,
            message)
        })
    },
    async RETIFICAR_TITULO (_this, { item }) {
      await this.executarTramitacao(item.id)
      this.$router.push({
        name: 'continuar-emissao-titulo',
        params: {
          idProcesso: item.id,
          tipo: 'RETIFICAR_TITULO',
          urlOrigem: 'CAIXA_ENTRADA'
        }
      })
    },
    REGERAR_PROCESSOS () {
      if (this.idsProcessos.length > 0) {
        this.confirmBox(this.$messages.AVISO_REGERAR, this.$messages.TITULO_WARNING,
          async () => {
            await this.regerar(this.idsProcessos)
            this.showNotificacao(this.$messages.TIPO_SUCCESS, this.$messages.TITULO_SUCCESS, 'Processo(s) enviados para a Fila')
            location.reload()
          },
          () => { }
        )
      }
    },
    VIEW_PROCESSOS_SUSPENSOS (_this, { item }) {
      this.idProcesso = item.id
      this.setor = item.setor
      this.numeroProcesso = item.numeroProcesso
      this.sIndireta = suspensaoIndireta(this.usuario.perfilSelecionado.nome)
      this.showModalSuspensaoProcesso = !this.showModalSuspensaoProcesso
    },
    CANCELAR_RETIFICACAO (_this, { item }) {
      this.idProcesso = item.id
      this.numeroProcesso = item.numeroProcesso
      this.protocolo = item.numeroProtocolo
      this.setor = item.setor
      this.showModalRetificacao = true
    },
    closeRetificacao (item) {
      this.showModalRetificacao = false
      this.refresh()
    }
  }
}
</script>
<style lang="scss" scoped>
.card-container {
  margin: 20px;
  border-radius: 10px;
}

.padding-left {
  padding-left: 25px;
}

@media (max-width: 780px) {
  .card-container {
    margin: 0 0 15px 0 !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/screens/analise/listagem/CaixaEntradaListagem.vue